import "./styles.scss";

import React from "react";
import { Link } from "gatsby";

import { headerData } from "data/header";

const Actions = ({ onClick }) => {
  const handleClick = (type) =>
    typeof onClick === "function" ? onClick(type) : undefined;

  return (
    <div className="header-mobile-actions">
      <Link
        className="header-mobile-actions__primary"
        to={headerData.reservation.url}
      >
        {headerData.reservation.label}
      </Link>
      <Link
        className="header-mobile-actions__secondary"
        to={headerData.question.url}
      >
        {headerData.question.label}
      </Link>
      <button
        className="header-mobile-actions__secondary"
        type="button"
        onClick={() => handleClick("call")}
      >
        {headerData.call.label}
      </button>
      <button
        className="header-mobile-actions__secondary"
        type="button"
        onClick={() => handleClick("location")}
      >
        {headerData.location.label}
      </button>
    </div>
  );
};

export default Actions;
